import { AppName } from '../..';
import { WhatsAppTemplateNames } from './whatsapp-template-name.enum';

export const WHATSAPP_MESSAGE_TYPES = ['text', 'template'] as const;
export const WA_MESSAGES_DAILY_THRESHOLD_DEFAULT = 2000;
export const WA_CONVERSATIONS_THRESHOLD_DEFAULT = 1000;
export const WA_CONVERSATIONS_THRESHOLD_TIMEFRAME_DEFAULT = 7;

export type WhatsAppMessageType = (typeof WHATSAPP_MESSAGE_TYPES)[number];

export interface IwhatsAppBaseMessage {
  type: WhatsAppMessageType;
  messaging_product: 'whatsapp';
  recipient_type: 'individual';
  to: string;
  appName: AppName;
}

export interface IwhatsAppText {
  body: string;
  preview_url?: string;
}

export interface IwhatsAppLanguage {
  policy?: 'deterministic';
  code: string;
}

export interface IwhatsAppTextMessage extends IwhatsAppBaseMessage {
  text: IwhatsAppText;
  /**
   * Public/presigned URLs Twilio fetches when sending media alongside (or instead of) the text body.
   */
  mediaUrls?: string[];
}

export interface IwhatsAppTemplateParameter {
  type: 'text' | 'currency' | 'date_time' | 'image' | 'document';
  text?: string; // For text parameters
  currency?: {
    // For currency parameters
    fallback_value: string;
    code: string;
    amount_1000: number;
  };
  date_time?: {
    // For date_time parameters
    fallback_value: string;
  };
  image?: {
    // For image parameters
    link: string; // URL of the image
  };
  document?: {
    // For document parameters
    link: string; // URL of the document
    filename?: string;
  };
}

export type IwhatsAppTemplateNamedParameter = Record<string, IwhatsAppTemplateParameter>;

export interface IwhatsAppComponents {
  type: 'header' | 'body' | 'footer' | 'button';
  index?: number;
  sub_type?: 'quick_reply' | 'url';
  parameters: IwhatsAppTemplateParameter[] | IwhatsAppTemplateNamedParameter;
}

export interface IwhatsAppTemplate {
  name: string | WhatsAppTemplateNames;
  language: IwhatsAppLanguage;
  components: IwhatsAppComponents[];
}

export interface IwhatsAppTemplateMessage extends IwhatsAppBaseMessage {
  template: IwhatsAppTemplate;
}

// WhatsAppMessage acts as an extendable union
export type WhatsAppMessage = IwhatsAppTextMessage | IwhatsAppTemplateMessage;

export enum WhatsAppServiceProvider {
  Twilio = 'twilio',
  Meta = 'meta',
}
